/**
 * Replaces characters not allowed in process labels (e.g. SQL node names).
 * Used by getUniqueProcessLabel and Graph utils.
 */
export function replaceNonAllowedChar(name: string) {
  return name.replaceAll(/[^a-zA-Z0-9-_.]/g, '').replaceAll(/[.-\s]/g, '_');
}
